import { faDollyFlatbed } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import React, { useCallback, useEffect, useState } from "react";
import { Alert, Button, ButtonGroup, Card, Tab } from "react-bootstrap";
import { Info } from "react-feather";

import ServerSideTable from "../../../../components/tables/ServerSideTable";
import tableColumns from "./tableColumns";

const ShipmentRacks = ({
  selectedAccount,
  shipmentRacks,
  setShipmentRacks,
  getShipmentRacks,
  shipmentCategories,
  setSelectedShipmentRacks,
  submitting,
  activeShipmentCategory,
  setActiveShipmentCategory,
}) => {
  const [isLoading, setIsLoading] = useState(false);
  const [paginationOptions, setPaginationOptions] = useState({
    pageIndex: 0,
    pageSize: 10,
    pageCount: 0,
  });
  const [totalCount, setTotalCount] = useState(0);

  // Fetch data when the activeShipmentCategory changes
  useEffect(() => {
    let isMounted = true;

    fetchData({
      pageIndex: 0,
      pageSize: 10,
      sortBy: [{ id: "lastUpdated", desc: true }],
    });

    return () => {
      isMounted = false;
    };
  }, [activeShipmentCategory]);

  const handleRowClick = (row) => {
    // if oversize shipment, allow multiple racks to be selected
    if (activeShipmentCategory === 2) {
      row.toggleRowSelected();
    }
    // standard shipment, only allow one rack to be selected
    else {
      setSelectedShipmentRacks([row.original]);
    }
  };

  const fetchData = useCallback(
    async (params) => {
      setIsLoading(true);

      console.log({ params });
      const { globalFilter, filters, pageIndex, pageSize, sortBy } = params;

      const queryParams = filters?.reduce((acc, curr) => {
        if (!acc[curr.id] && curr.id !== "lastUpdated") {
          acc[curr.id] = curr.value;
        } else if (curr.id === "lastUpdated") {
          acc["lastUpdatedStart"] = curr.value[0];
          acc["lastUpdatedEnd"] = curr.value[1];
        }

        return acc;
      }, {});

      const result = await getShipmentRacks({
        listingAccountId: selectedAccount.listingAccountId,
        shipmentRackStatus: 3,
        shipmentCategoryId: activeShipmentCategory,
        globalSearch: globalFilter,
        ...queryParams,
        pageIndex,
        pageSize,
        sortBy,
      });

      console.log({ result });

      setShipmentRacks(result.shipmentRacks);
      setPaginationOptions({
        pageIndex: result.pageIndex,
        pageSize: result.pageSize,
        pageCount: result.pageCount,
      });
      setTotalCount(result.totalCount);

      setIsLoading(false);
    },
    [activeShipmentCategory, getShipmentRacks, selectedAccount]
  );

  return (
    <Card>
      <Tab.Container activeKey={activeShipmentCategory}>
        <Card.Header>
          <div className="d-flex justify-content-start mb-3">
            <FontAwesomeIcon icon={faDollyFlatbed} size="3x" className="me-3" />
            <div>
              <Card.Title>Shipment Racks</Card.Title>
              <Card.Subtitle>
                Select a shipment category below to view{" "}
                <strong>{selectedAccount.listingAccount}</strong>'s shipment
                racks.
              </Card.Subtitle>
            </div>
          </div>
          <ButtonGroup className="d-flex">
            {shipmentCategories
              .filter(
                (category) =>
                  category.shipmentCategoryId === 1 ||
                  category.shipmentCategoryId === 2
              )
              .map((category, index) => {
                return (
                  <Button
                    key={index}
                    variant="outline-primary"
                    onClick={() => {
                      setActiveShipmentCategory(category.shipmentCategoryId);
                    }}
                    className={
                      activeShipmentCategory === category.shipmentCategoryId
                        ? "active"
                        : ""
                    }
                    disabled={submitting}
                  >
                    {category.shipmentCategory}
                  </Button>
                );
              })}
          </ButtonGroup>
        </Card.Header>
        <Tab.Content>
          {shipmentCategories.length > 0 ? (
            shipmentCategories.map((category, index) => {
              return (
                <Tab.Pane key={index} eventKey={category.shipmentCategoryId}>
                  <Card.Body>
                    {activeShipmentCategory && (
                      <ServerSideTable
                        key={activeShipmentCategory}
                        columns={tableColumns}
                        data={shipmentRacks}
                        fetchData={fetchData}
                        isLoading={isLoading}
                        paginationOptions={paginationOptions}
                        totalCount={totalCount}
                        handleRowClick={handleRowClick}
                        setSelectedRows={setSelectedShipmentRacks}
                        useCheckboxes={
                          activeShipmentCategory === 1 ? false : true
                        }
                        submitting={submitting}
                        layoutFixed={
                          activeShipmentCategory !== 1 ? false : true
                        }
                      />
                    )}
                  </Card.Body>
                </Tab.Pane>
              );
            })
          ) : (
            <Card.Body>
              <Alert variant="warning">
                <div className="alert-icon">
                  <Info
                    className="position-relative top-50 start-50 translate-middle"
                    size={20}
                  />
                </div>
                <div className="alert-message">
                  There doesn't seem to be any shipment racks for{" "}
                  <strong>{selectedAccount.listingAccount}</strong>. Try
                  selecting a different account to view current shipment racks.
                </div>
              </Alert>
            </Card.Body>
          )}
        </Tab.Content>
      </Tab.Container>
    </Card>
  );
};

export default ShipmentRacks;
